import axios from 'axios';
import { hasCookiebotStatisticsConsent } from '@/utils/to-consent-aware-tracking-event';

const serverApiBaseUrl =
  process.env.API_BASE_URL ?? process.env.NEXT_PUBLIC_API_BASE_URL?.replace(/\/$/, '');

const httpClient = axios.create({
  baseURL: serverApiBaseUrl,
  withCredentials: false,
  // Skip axios's built-in HTTP_PROXY/HTTPS_PROXY/NO_PROXY auto-detection
  // (handled by the transitive `proxy-from-env`, which still calls the
  // legacy `url.parse()` and triggers Node's DEP0169 warning on every
  // server-side request). We don't route outbound API traffic through a
  // proxy in any environment, so disabling the lookup is a no-op for
  // behaviour and removes the deprecation noise from the dev console.
  proxy: false,
  auth: {
    username: process.env.AUTH_BASIC_USERNAME!,
    password: process.env.AUTH_BASIC_PASSWORD!,
  },
  headers: {
    'x-realm-name': process.env.AUTH_SERVER_REALM!,
    'x-clinet-id': process.env.NEXT_PUBLIC_AUTH_SERVER_CLIENT_ID!,
  },
});

httpClient.interceptors.request.use(config => {
  config.withCredentials = hasCookiebotStatisticsConsent();
  return config;
});

// `withCredentials: true` lets the browser attach first-party cookies (e.g.
// the `locale` cookie) on cross-origin XHR. The API must respond with:
//   Access-Control-Allow-Credentials: true
//   Access-Control-Allow-Origin: <exact frontend origin>   (no wildcard)
export const runtimeHttpClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  withCredentials: true,
  proxy: false,
});

export { httpClient };
